var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"pagination"},[_c('el-pagination',{attrs:{"background":"","layout":"total, prev, pager, next, jumper","total":_vm.total,"current-page":_vm.now,"page-size":_vm.pageSize},on:{"current-change":_vm.change}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }